var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 81,
    viewBox: "0 0 179 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 139,
    height: 41,
    rx: 10,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M83.53 46V33.544H91.108V34.768H84.916V39.07H90.028V40.276H84.916V44.776H91.108V46H83.53ZM92.3452 37H93.8212L96.0172 40.528L98.2132 37H99.6892L96.8272 41.464L99.6712 46H98.1952L96.0172 42.49L93.8212 46H92.3452L95.1712 41.5L92.3452 37ZM101.384 49.996V37H102.716V37.648C103.628 37.096 104.528 36.82 105.416 36.82C106.556 36.82 107.384 37.186 107.9 37.918C108.416 38.638 108.674 39.832 108.674 41.5C108.674 43.168 108.368 44.368 107.756 45.1C107.156 45.82 106.154 46.18 104.75 46.18C104.018 46.18 103.346 46.114 102.734 45.982V49.996H101.384ZM105.218 38.026C104.858 38.026 104.468 38.086 104.048 38.206C103.64 38.326 103.316 38.446 103.076 38.566L102.734 38.746V44.812C103.586 44.944 104.234 45.01 104.678 45.01C105.65 45.01 106.328 44.734 106.712 44.182C107.108 43.63 107.306 42.73 107.306 41.482C107.306 40.234 107.126 39.346 106.766 38.818C106.418 38.29 105.902 38.026 105.218 38.026ZM110.48 41.482C110.48 39.838 110.774 38.65 111.362 37.918C111.95 37.186 112.94 36.82 114.332 36.82C115.736 36.82 116.726 37.186 117.302 37.918C117.89 38.65 118.184 39.838 118.184 41.482C118.184 43.126 117.908 44.32 117.356 45.064C116.804 45.808 115.796 46.18 114.332 46.18C112.868 46.18 111.86 45.808 111.308 45.064C110.756 44.32 110.48 43.126 110.48 41.482ZM111.866 41.464C111.866 42.772 112.022 43.69 112.334 44.218C112.658 44.746 113.324 45.01 114.332 45.01C115.352 45.01 116.018 44.752 116.33 44.236C116.642 43.708 116.798 42.784 116.798 41.464C116.798 40.144 116.624 39.238 116.276 38.746C115.928 38.242 115.28 37.99 114.332 37.99C113.396 37.99 112.748 38.242 112.388 38.746C112.04 39.238 111.866 40.144 111.866 41.464ZM120.386 46V37H121.718V38.224C122.762 37.504 123.86 37.03 125.012 36.802V38.17C124.508 38.266 123.98 38.416 123.428 38.62C122.888 38.824 122.474 39.004 122.186 39.16L121.736 39.394V46H120.386ZM131.271 38.17H128.409V42.472C128.409 43.504 128.481 44.182 128.625 44.506C128.781 44.83 129.141 44.992 129.705 44.992L131.307 44.884L131.397 46C130.593 46.132 129.981 46.198 129.561 46.198C128.625 46.198 127.977 45.97 127.617 45.514C127.257 45.058 127.077 44.188 127.077 42.904V38.17H125.799V37H127.077V34.246H128.409V37H131.271V38.17Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59 43V46H47V43H45V46C45 47.1 45.9 48 47 48H59C60.1 48 61 47.1 61 46V43H59ZM48 37L49.41 38.41L52 35.83V44H54V35.83L56.59 38.41L58 37L53 32L48 37Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 0,
    y: 0,
    width: 179,
    height: 81,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.2911f75fc8ddf117ef2cbc888bb45b6a.svg";
export { ForwardRef as ReactComponent };